
import React from 'react';
import './Testimonials.css';
import Avatar from 'react-avatar';


const defaultTestimonials = [
  {
    id: 1,
    name: 'Neha Kapoor',
    role: 'Software Developer (Placed)',
    avatar: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg',
    text: 'I got my dream job through this platform. The application process was super simple and transparent!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Simran Kaur',
    role: 'Job Seeker (Fresher)',
    avatar: 'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg',
    text: 'As a fresher, I was nervous about applying, but this portal made everything smooth. Got interviews quickly!',
    rating: 5,
  },
  {
    id: 3,
    name: 'Amit Verma',
    role: 'Marketing Executive (Placed)',
    avatar: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg',
    text: 'The website connected me with the right company. Within two weeks, I had an offer letter in hand!',
    rating: 5,
  },
  {
    id: 4,
    name: 'Ritika Joshi',
    role: 'Job Seeker',
    avatar: 'https://images.pexels.com/photos/1130626/pexels-photo-1130626.jpeg',
    text: 'I loved how easy it was to filter jobs by location and role. Found exactly what I was looking for.',
    rating: 4,
  },
  {
    id: 5,
    name: 'Deepak Yadav',
    role: 'Mechanical Engineer',
    avatar: 'https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg',
    text: 'Most job portals ignore core engineering jobs, but here I found multiple openings in my domain.',
    rating: 5,
  },
  {
    id: 6,
    name: 'Shreya Gupta',
    role: 'MBA Graduate (Job Seeker)',
    avatar: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg',
    text: 'The career resources and resume tips really helped me stand out in interviews. Thank you!',
    rating: 5,
  },
  {
    id: 7,
    name: 'Rahul Mehta',
    role: 'Data Analyst (Placed)',
    avatar: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg',
    text: 'This platform helped me land a data analyst role in a top company. Super happy with the experience!',
    rating: 5,
  },
  {
    id: 8,
    name: 'Pooja Nair',
    role: 'Job Seeker',
    avatar: 'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg',
    text: 'The email alerts kept me updated about new openings. I never missed an opportunity!',
    rating: 4,
  },
  {
    id: 9,
    name: 'Arjun Reddy',
    role: 'Civil Engineer (Placed)',
    avatar: 'https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg', // Indian man
    text: 'Finally found the right platform that values core engineering jobs. Got placed in a reputed construction firm!',
    rating: 5,
  },
];


export default function Testimonials({ testimonials = defaultTestimonials}) {
  return (
    <section className="testimonials" aria-label="Customer testimonials">
      <div className="testimonials-inner">
        {/* <h2 className="testimonials-heading">{heading}</h2> */}
        <div className="testimonials-grid">
          {testimonials.map((t) => (
            <blockquote key={t.id} className="testimonial-card">
              <div className="testimonial-top">
                <div className="testimonial-avatar">
                  <Avatar
                    name={t.name}
                    src={t.avatar || undefined}
                    size="64"
                    round={true}
                    color="#0ea5a4"
                    fgColor="#fff"
                    maxInitials={2}
                  />
                </div>
                <div className="testimonial-meta">
                  <p className="testimonial-name">{t.name}</p>
                  <p className="testimonial-role">{t.role}</p>
                </div>
              </div>

              <p className="testimonial-text">“{t.text}”</p>

              <div className="testimonial-rating" aria-hidden>
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className={i < (t.rating || 0) ? 'star filled' : 'star'}>★</span>
                ))}
              </div>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}

